module.exports = __webpack_public_path__ + "static/img/13introduce.3b4afcfe.jpg";